module.exports = __webpack_public_path__ + "img/bg_t_2.95eea89b.png";